import { createTheme } from '@material-ui/core/styles';

export const theme = createTheme({
    palette: {
        primary: {
            light: '#49b784',
            main: '#198754',
            dark: '#005724',
            contrastText: '#fff',
        },
        secondary: {
            light: '#666666',
            main: '#333333',
            dark: '#000000',
            contrastText: '#fff',
        },
    },
});
